import {listGender} from "data/list";
import React from "react";
import {FIELD_TYPE, FORMAT_TIME} from "types/enums";
import {ColumnsEdit} from "types/models/column-table-edit";
const {INPUT, CURRENCY, DATE, NUMBER, COMBO_BOX, LIST, AUTO_COMPLETE} =
  FIELD_TYPE;
const fields: any[] = [
  {
    type: INPUT,
    label: "Mã đơn thuốc",

    name: "donKeId",
    disable: true,
  },
  {
    type: INPUT,
    label: "BS kê đơn",

    name: "tenBacSy",
    disable: true,
  },
  {
    type: INPUT,
    label: "Mã bệnh nhân",

    name: "maBenhNhan",
    disable: true,
  },

  {
    type: INPUT,
    label: "Tên bệnh nhân",
    name: "hoTen",
  },
  {
    type: COMBO_BOX,
    label: "Giới tính",
    name: "gioiTinh",
    options: listGender,
  },

  {
    type: DATE,
    label: "Ngày sinh",
    name: "ngaySinh",
  },

  {
    type: INPUT,
    label: "Số điện thoại",
    name: "dienThoai",
  },
  {
    type: INPUT,
    label: "Địa chỉ",
    name: "diaChi",
  },
  {
    type: DATE,
    label: "Thời gian khám",
    name: "thoiGianKham",
    optionsTime: {showTime: true, format: FORMAT_TIME.dateTime},
    disable: true,
  },
  {
    type: COMBO_BOX,
    label: "Kho",
    name: "storeId",
    disabled: true,
  },
  // {
  //   type: COMBO_BOX,
  //   label: "Trạng thái",
  //   name: "status",
  //   options: [
  //     {value: "CB", label: "Chưa bán"},
  //     {value: "DB", label: "Đã bán"},
  //   ],
  //   disable: true,
  // },
  // {
  //   type: COMBO_BOX,
  //   label: "Hình thức thanh toán",
  //   name: "paymentsId",
  //   rules: [{required: true, message: "Chưa chọn hình thức thanh toán"}],
  // },
  // {
  //   type: INPUT,
  //   label: "Người bán",
  //   name: "nguoiBan",
  //   value: localStorage.getItem("username"),
  // },
];
const columns: ColumnsEdit = [
  {
    title: "STT",
    dataIndex: "stt",
    key: "stt",
    render: (text, record, index) => index + 1,
    width: 80,
    show: true,
    align: "center",
  },
  {
    type: INPUT,
    dataIndex: "id",
    key: "id",
    title: "",
    width: 0,
  },

  {
    type: AUTO_COMPLETE,
    dataIndex: "soLo",
    key: "soLo",
    title: "Số lô",
    show: false,
  },
  {
    type: AUTO_COMPLETE,
    dataIndex: "thuocId",
    key: "thuocId",
    title: "Mã sản phẩm",
    show: true,
    autoFocus: true,
  },

  {
    type: AUTO_COMPLETE,
    dataIndex: "tenThuoc",
    key: "tenThuoc",
    title: "Tên thuốc",

    show: true,
  },

  {
    type: INPUT,
    dataIndex: "donViKe",
    key: "donViKe",
    title: "Đơn vị kê",
    show: true,
    disabled: true,
  },
  {
    type: NUMBER,
    dataIndex: "soLuongKe",
    key: "soLuongKe",
    title: "Số lượng kê",
    show: true,
    disabled: true,
    align: "right"
  },
  {
    type: NUMBER,
    title: "Số lượng tồn",
    dataIndex: "tonKho",
    disabled: true,
    show: true,
    align: "right"
  },
  {
    type: COMBO_BOX,
    dataIndex: "donViCapPhatId",
    key: "donViCapPhatId",
    title: "Đơn vị cấp phát",
    show: true,
  },
  {
    type: NUMBER,
    dataIndex: "soLuongCapPhat",
    key: "soLuongCapPhat",
    title: "Số lượng cấp phát",
    show: true,
    align: "right"
  },

  {
    type: DATE,
    dataIndex: "hanSuDung",
    key: "hanSuDung",
    title: "Hạn sử dụng",
    show: true,
  },
  {
    type: COMBO_BOX,
    dataIndex: "duocChinhId",
    key: "duocChinhId",
    title: "Dược chính",
    show: true,
    disabled: true,
  },
  {
    type: COMBO_BOX,
    dataIndex: "baoCheId",
    key: "baoCheId",
    title: "Dạng bào chế",
    show: true,
    disabled: true,
  },
  {
    type: INPUT,
    dataIndex: "hoatChat",
    key: "hoatChat",
    title: "Hoạt chất",
    show: true,
    disabled: true,
  },
  {
    type: INPUT,
    dataIndex: "hamLuong",
    key: "hamLuong",
    title: "Nồng độ/Hàm lượng",
    show: true,
    disabled: true,
  },
  {
    type: INPUT,
    dataIndex: "lieuDung",
    key: "lieuDung",
    title: "Liều dùng",
    show: true,
    disabled: true,
  },
  {
    type: INPUT,
    dataIndex: "soDangKy",
    key: "soDangKy",
    title: "Số đăng ký",
    show: true,
    disabled: true,
  },
  {
    type: INPUT,
    dataIndex: "tenBH",
    key: "tenBH",
    title: "Tên theo BH",
    show: true,
    disabled: true,
  },

  {
    type: INPUT,
    dataIndex: "ghiChu",
    key: "ghiChu",
    title: "Ghi chú",
    show: true,
  },
  {
    title: "",
    dataIndex: "",
    key: "action",
    align: "center",
    width: 60,
    fixed: "right" as any,
    show: true,
  },
];

export {columns, fields};
